import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

interface IOption {
  color: string;
  value: string;
  label: string;
}

export default /*#__PURE__*/_defineComponent({
  props: {
    options: null,
    value: null
  },
  setup(__props: any) {

const props = __props as {
  options: IOption[];
  value: string;
}



const selectedOption = computed(() => {
  return props.options.find((item) => item.value === props.value);
});

const tagClass = computed(() => {
  const color = selectedOption.value?.color || "";
  if (color.includes("green") || color.includes("success")) return "tag--success";
  if (color.includes("yellow") || color.includes("warning") || color.includes("orange"))
    return "tag--warning";
  if (color.includes("red") || color.includes("error")) return "tag--error";
  if (color.includes("blue") || color.includes("info")) return "tag--info";
  return "tag--default";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["tag", _unref(tagClass)])
  }, _toDisplayString(_unref(selectedOption) ? _unref(selectedOption).label : "Не указано"), 3))
}
}

})